module.exports = __webpack_public_path__ + "static/media/landingthree.83b63f29.png";